import React from 'react';
import { Link } from "react-router-dom";
import { MyContext } from '../context';
import { Content, BadgeMenu } from '../components';
import DriverModal from '../modal/DriverModal';
import { db, functions } from '../firebase';
export default class WithdrawRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: 0,
      target: null
    }
  }
  subMenu() {
    return (
      <li className="m-nav__item">
        <Link to={window.location.pathname} className="m-nav__link">
          <span className="m-nav__link-text">Withdraw Request</span>
        </Link>
      </li>
    )
  }
  leftMenu() {
    return (
      <MyContext.Consumer>
        {state => {
          return (
            <React.Fragment>
              {
                state.driverList && state.withdrawRequest && state.withdrawFunded &&
                <React.Fragment>
                  <BadgeMenu className="m-badge m-badge--danger" onClick={(e) => { this.filter(0) }} title="All Withdraw Request" value={state.withdrawRequest.length} />
                  <BadgeMenu className="m-badge m-badge--danger" onClick={(e) => { this.filter(1) }} title="All Withdraw Funded" value={state.withdrawFunded.length} />
                </React.Fragment>
              }
            </React.Fragment>)
        }}
      </MyContext.Consumer>
    )
  }
  filter(filter) {
    this.setState({
      filter
    })
  }
  render() {
    return <Content title="Withdraw Request" state={this} />
  }
  content() {
    return (
      <MyContext.Consumer>
        {state => {
          let sn = 0;
          return (
            <React.Fragment>
              {
                this.state.filter != null && <table id="example" className="table table-striped table-bordered" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>S.N.</th>
                      <th>Driver Name</th>
                      <th>Request Amount</th>
                      <th>Request A/C and type</th>
                      <th>Requested Time</th>
                      <th>Status</th>
                      {this.state.filter != 0 && <th>Releases Time</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      state.driverList && state.withdrawRequest &&

                      this.filterData(state)
                    }
                  </tbody>
                </table>}
              <DriverModal show={this.state.driver ? true : false} driver={this.state.driver} title="Deriver Details" footer={
                <div className="modal-footer" style={{ padding: 0 }}>
                  <button type="button" className="btn btn-primary" onClick={e => {
                    db.writeData(`admin/withdrawRequest/${this.state.item.key}/releaseTimestamp`, new Date().getTime());
                    db.writeData(`admin/withdrawRequest/${this.state.item.key}/funded`, true);
                    functions.sendNotification({
                      token: this.state.driver.FCMtoken,
                      title: "Withdraw Request Accept and Funded",
                      body: `You requested payment of $ ${this.state.item.amount} has been funded.`,
                      data: {
                        url: "withdrawHistory"
                      }
                    })
                    this.setState({
                      driver: null,
                      item: null
                    })
                  }}>Releases Fund</button>
                </div>
              } hide={e => { this.setState({ driver: null, item: null }) }} />
            </React.Fragment>
          )
        }}
      </MyContext.Consumer>
    )
  }
  comp(item, sn) {
    var strDate = "";
    if (item.createdTimestamp) {
      let date = new Date(item.time);
      let month = date.getMonth() + 1
      strDate = (date.getDate() >= 10 ? date.getDate() : "0" + date.getDate()) + "/" + (month < 10 ? "0" + month : month) + "/" + date.getFullYear();
    }
    return (
      <tr key={item.key}>
        <td>{sn}</td>
        <td>{}</td>
        <td>{strDate}</td>
      </tr>
    )
  }
  filterData(state) {
    let sn = 0;
    if (this.state.filter == 0) {
      return state.withdrawRequest.map(item => {
        return this.data(state, item, sn++)
      })
    } else {
      return state.withdrawFunded.map(item => {
        return this.data(state, item, sn++)
      })
    }
  }
  data(state, item, sn) {
    sn++;
    var strDate = "";
    var endDate = "";
    if (item.createdTimestamp) {
      let date = new Date(item.createdTimestamp);
      let month = date.getMonth() + 1
      strDate = (date.getDate() >= 10 ? date.getDate() : "0" + date.getDate()) + "/" + (month < 10 ? "0" + month : month) + "/" + date.getFullYear();
    }
    if (item.releaseTimestamp) {
      let date = new Date(item.releaseTimestamp);
      let month = date.getMonth() + 1
      endDate = (date.getDate() >= 10 ? date.getDate() : "0" + date.getDate()) + "/" + (month < 10 ? "0" + month : month) + "/" + date.getFullYear();
    }
    let fun = () => {
      if (item.funded) {
        return;
      }
      this.setState({
        driver: state.driverList[item.driverKey],
        item: item
      })
    }
    if (state.driverList[item.driverKey]) {
      return (
        <tr key={item.key} style={{ cursor: "pointer" }}>
          <td onClick={fun}>{sn}</td>
          <td onClick={fun}>{state.driverList[item.driverKey].fullName}</td>
          <td onClick={fun}>$ {item.amount}</td>
          <td onClick={fun}>{item.withdrawAccountDetail} / {item.withdrawBy}</td>
          <td onClick={fun}>{strDate}</td>
          <td onClick={fun}>{item.funded ? "Funded" : "Request"}</td>
          {this.state.filter != 0 && <td onClick={fun}>{endDate}</td>}
        </tr>
      )
    } else {
      sn--;
    }
  }
}


// WEBPACK FOOTER //
// ./src/include/WithdrawRequest.js